import React from 'react';

function Contact({ ContactContent, LanguageSelected, t, phoneNumbers, textRef, divstyle }) {
  function formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.toString();
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const formattedNumber = cleanedNumber.replace(/(\d{3})(?=\d)/g, '$1 ');

    return formattedNumber;
  }
  return (
    <div>
      {ContactContent != '' && ContactContent.length > 0 && (
        <div className={`pt-3 pb-2 pl-3 pr-3  ${divstyle} w-full`}>
          <h1
            className={`${LanguageSelected === 'ar'
                ? 'title title--h1 first-title title__separate text-theme right-2'
                : 'title left-2 title--h1 first-title title__separate text-theme'
              }`}
          >
            {t("Informations de contact")}
          </h1>

          <ul className="p-2 grid place-items-start gap-2 text-about ">
            {ContactContent[0]?.location != null && (
              <a href={`https://maps.google.com/maps?q=${encodeURIComponent(ContactContent[0].location)}`} className='mb-0.5' target='_blank'>
                <li className="text-theme flex items-center gap-2 text-about  w-80" data-toggle="tooltip" data-placement="top" title="Address">
                  <i className={`${LanguageSelected == 'ar' ? 'fas fa-map-marker-alt text-[#C8A443] inline-block text-xl ml-3' : 'fas fa-map-marker-alt inline-block text-[#C8A443] text-xl mr-3'}`}></i>
                  <p className='inline-block' dir="auto">
                    {ContactContent[0].location}
                  </p>
                </li>
              </a>
            )}

            {ContactContent[0]?.email != null && (
              <>
                <hr className="border w-full border-gray-500 opacity-10" />
                <a href={`mailto:${ContactContent[0].email}`}>
                  <li className="text-theme contacts-block__item w-80 " data-toggle="tooltip" data-placement="top" title="E-mail">
                    <i className={`${LanguageSelected == 'ar' ? 'far fa-envelope text-xl text-[#C8A443] ml-3' : 'far fa-envelope text-xl text-[#C8A443] mr-3'}`}></i> <bdi dir="ltr">{ContactContent[0].email}</bdi>
                  </li>
                </a>
              </>
            )}

            {ContactContent[0]?.website != null && (
              <>
                <hr className="border w-full border-gray-500 opacity-10" />
                <a href={ContactContent[0].website} target='_blank'>
                  <li className="text-theme contacts-block__item w-80" data-toggle="tooltip" data-placement="top" title="Phone">
                    <i className={`${LanguageSelected == 'ar' ? 'fas fa-globe  text-xl text-[#C8A443] ml-3' : 'fas fa-globe  text-xl text-[#C8A443] mr-3'}`}></i> <bdi dir="ltr">{ContactContent[0].website}</bdi>
                  </li>
                </a>
              </>
            )}

            {phoneNumbers &&
              phoneNumbers.map((phonenumber, index) => {
                if (phonenumber && phonenumber.phone != null) {
                  return (

                    <>
                      <hr className="border w-full border-gray-500 opacity-10" />

                      <div className='grid place-items-start mt-1 mb-1' key={index}>

                        <li className="text-theme items-start flex items-center" data-toggle="tooltip" data-placement="top" title="Phone">
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className={`${LanguageSelected == 'ar' ? 'w-6 h-6 text-gold text-xl ml-3' : 'w-6 h-6 text-gold text-xl mr-3'}`}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.970c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" />
                          </svg>
                          <a className="text-theme" dir="ltr" ref={textRef}>{phonenumber.prefixPhone} {formatPhoneNumber(phonenumber.phone)}</a>
                        </li>
                      </div>
                    </>
                  )
                }
              }





              )}


          </ul>
        </div>
      )}
    </div>
  );
}

export default Contact;
